import React from 'react';
import { TransformControls as DreiTransformControls } from '@react-three/drei';
import { SceneObject } from '../../../types';

interface TransformControlsProps {
  objects: SceneObject[];
  mode: 'translate' | 'rotate' | 'scale';
  enabled: boolean;
}

export const TransformControls: React.FC<TransformControlsProps> = ({ objects, mode, enabled }) => {
  if (!enabled || objects.length === 0) return null;

  // For now, only transform the first selected object
  const primaryObject = objects[0];

  return (
    <DreiTransformControls
      object={undefined} // Will be set by Three.js
      mode={mode}
      enabled={enabled}
      size={1}
      showX={true}
      showY={true}
      showZ={true}
      space="world"
      onObjectChange={() => {
        // Handle object transformation
        console.log('Object transformed');
      }}
    />
  );
};
